import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
const { Option } = Select;

/**
 * Props:
 * - stateId: string (required — filters cities by state)
 * - value: string (optional, for controlled mode in Form.Item)
 * - onChange: function (cityId) => void
 * - disabled: boolean
 */
const CitySelect = ({ stateId, value, onChange, disabled = false }) => {

  const { request } = useRequest();
  const [cityList, setCityList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCities = () => {
    if (!stateId) {
      setCityList([]);
      return;
    }

    setLoading(true);
    request({
      url: `${apiPath.commonCity}?state_id=${stateId}`,
      method: "GET",
      onSuccess: (res) => {
        const cities = res?.data?.data || [];
        setCityList(cities);
        setLoading(false);
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(err?.response?.data?.message || "Failed to load cities", Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    fetchCities();
  }, [stateId]);

  return (
    <Spin spinning={loading} tip="Loading cities..." size="small">
      <Select
        showSearch
        allowClear
        placeholder={stateId ? "Select city" : "Select state first"}
        optionFilterProp="children"
        value={value}
        onChange={(val) => onChange?.(val)}
        disabled={!stateId || disabled}
        loading={loading}
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        className="w-full"
        style={{ height: 40 }}
      >
        {cityList?.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.en_name}
          </Option>
        ))}
      </Select>
    </Spin>
  );
};

export default CitySelect;
